import { Box, Tab, Tabs } from '@mui/material'
import React from 'react'
import * as PXBColors from '@brightlayer-ui/colors';
import SetInputs from './SetInputs';
import SetOutputs from './SetOutputs';
import { useLanguageLocale } from '../../../../hooks/language-locale-hooks';

const TAB_STATE_KEY = 'backState';
const TAB_INPUT_KEY = 0;
const TAB_OUTPUT_KEY = 1;
const TAB_INPUT = "Inputs";
const TAB_OUTPUT = "Outputs";

export const getTabState = (): number => {
    const tabState = sessionStorage.getItem(TAB_STATE_KEY);
    switch (tabState) {
        case TAB_INPUT:
            return TAB_INPUT_KEY;
        case TAB_OUTPUT:
            return TAB_OUTPUT_KEY;
        default:
            return TAB_INPUT_KEY;
    }
};

export const updateTabSession = (tab: string): void => {
    sessionStorage.setItem(TAB_STATE_KEY, tab);
};

type Props = {

};

const SetInputOutput = (props: Props) => {
    const [value, setValue] = React.useState(getTabState());
    const { t } = useLanguageLocale();

    updateTabSession(TAB_INPUT);

    function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
        const { children, value, index, ...other } = props;
        return <div {...other}>{value === index && <Box p={3}>{children}</Box>}</div>;
    }

    const handleTabChange = (event: any, newValue: React.SetStateAction<number>) => {
        setValue(newValue);
    };

    return (
        <>
            <div data-testid="set_input_output_container">
                <Box sx={{ display: 'flex' }} data-testid="set-input-output-container">
                    <Tabs orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleTabChange}
                        aria-label="Vertical tabs example"
                        sx={{
                            borderRight: 1,
                            width: "20%",
                            borderColor: 'divider',
                            '& .MuiTab-root': {
                                color: PXBColors.gray[500],
                                '&.Mui-selected': {
                                    color: PXBColors.blue[500],
                                    backgroundColor: PXBColors.blue[50]
                                }
                            },
                        }}>
                        <Tab value={TAB_INPUT_KEY} data-testid="setInputsTab" label={t('DUALSMART.DS_INPUTS')} />
                        <Tab value={TAB_OUTPUT_KEY} data-testid="setOutputsTab" label={t('ATPLUS.ATPLUS_DRYCONTACT_STATUS_OUTPUT')} />
                    </Tabs>
                    <TabPanel value={value} index={TAB_INPUT_KEY} sx={{ color: PXBColors.gray[500] }} data-testid="set-inputs-tab-panel">
                        <SetInputs />
                    </TabPanel>
                    <TabPanel value={value} index={TAB_OUTPUT_KEY} sx={{ color: PXBColors.gray[500] }} data-testid="set-outputs-tab-panel">
                        <SetOutputs />
                    </TabPanel>
                </Box>
            </div>
        </>
    )
}
export default SetInputOutput
